import { Routes, RouterModule } from '@angular/router';
import { KhaoSatClientComponent } from './khao-sat-client.component';

const routes: Routes = [
    {
        path: '',
        component: KhaoSatClientComponent
    },
];

export const KhaoSatClientRoutes = RouterModule.forChild(routes);
